module.exports = "pegasus/assets/email1-header-2.png";